export default function StatsSection() {
  const stats = [
    { value: "15+", label: "Product Categories" },
    { value: "50K+", label: "Listed Products" },
    { value: "10K+", label: "Happy Shoppers" },
  ];

  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-20">
          <div className="w-full lg:w-1/2">
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
              Shopping Made
              <br />
              Simple &amp; Smart
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 max-w-lg leading-relaxed">
              Sugargoo Spreadsheet transforms how you shop — bringing clarity, organization, and cost savings to every order. Join thousands of savvy shoppers who have already discovered the smarter way to shop online.
            </p>
          </div>

          <div className="w-full lg:w-1/2">
            <div className="relative overflow-hidden rounded-2xl bg-accent-50/50 p-8 md:p-10">
              <div className="absolute top-0 right-0 w-48 h-48 rounded-full bg-accent-100/60 -translate-y-1/2 translate-x-1/3"></div>
              <div className="absolute bottom-0 left-0 w-40 h-40 rounded-full bg-primary-100/40 translate-y-1/3 -translate-x-1/4"></div>

              <div className="relative grid grid-cols-3 gap-4">
                {stats.map((stat, idx) => (
                  <div key={idx} className="text-center">
                    <span className="block font-heading text-3xl md:text-5xl font-bold text-primary-500">
                      {stat.value}
                    </span>
                    <span className="block mt-2 text-xs md:text-sm text-foreground-600 leading-snug">
                      {stat.label}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}